import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { StyleSheet, Text, View } from "react-native";

import global from "../../styles/globalStyles";
import { supabase } from "../../utils/supabase";

import {
  PrimaryButton,
  FooterLinks,
  Header,
  Input,
} from "../common/native/index";

const ResetPassword = () => {
  const navigate = useNavigate();

  const [step, setStep] = useState<number>(1);
  const [password, setPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [errorMessageStep1, setErrorMessageStep1] = useState<string>("");
  const [errorMessageStep2, setErrorMessageStep2] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);

  const resetPassword = (password: string) =>
    supabase.auth.updateUser({ password: password });

  const handleOnPressResetPassword = async () => {
    if (password !== confirmPassword) {
      setErrorMessageStep1("Please make sure your passwords match.");
      return;
    }
    if (password.length < 8) {
      setErrorMessageStep1("Invalid password");
      return;
    }

    setLoading(true);
    try {
      const { data, error } = await resetPassword(password);
      if (error) setErrorMessageStep1(error.message);
      if (!error) setStep((prevStep) => prevStep + 1);
    } catch (error) {
      setErrorMessageStep1("Error in Updating Password. Please try again");
    }
    setLoading(false);
  };

  return (
    <View style={styles.container}>
      <Header />
      <View
        style={{
          width: "100%",
          maxWidth: 434,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {step === 1 && (
          <>
            <Text style={[global.title, { marginBottom: 24 }]}>
              Reset Password
            </Text>
            <Input
              name="New Password"
              placeholder="Enter your password"
              value={password}
              onChangeText={setPassword}
              secureTextEntry
              required
            />
            <Input
              name="Confirm Password"
              placeholder="Re-enter your password"
              value={confirmPassword}
              onChangeText={setConfirmPassword}
              secureTextEntry
              required
            />
            <View style={{ marginBottom: 12 }} />
            {errorMessageStep1 !== "" && (
              <Text style={[global.errorText]}>{errorMessageStep1}</Text>
            )}
            <View style={{ marginBottom: 12 }} />
            <PrimaryButton
              text="Reset Password"
              fullWidth
              onPress={handleOnPressResetPassword}
              disabled={password && confirmPassword ? false : true}
              loading={loading}
            />
          </>
        )}

        {step === 2 && (
          <>
            <Text style={[global.title, { marginBottom: 24 }]}>
              Password Changed
            </Text>
            <Text style={[global.text, { marginBottom: 10 }]}>
              Your password has been{" "}
              <Text style={global.fontWeight600}>successfully changed!</Text>
            </Text>
            <View style={{ marginBottom: 12 }} />
            {errorMessageStep2 !== "" && (
              <Text style={[global.errorText]}>{errorMessageStep2}</Text>
            )}
            <View style={{ marginBottom: 12 }} />
            <PrimaryButton
              text="Back to Login"
              fullWidth
              loading={loading}
              onPress={async () => {
                setLoading(true);
                const { error } = await supabase.auth.signOut();
                if (error) setErrorMessageStep2("Error logging out");
                if (!error) navigate("/signin");
                setLoading(false);
              }}
            />
          </>
        )}
      </View>
      <FooterLinks />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    alignSelf: "center",
    justifyContent: "space-between",
    minHeight: "100%",
    width: "100%",
    gap: 32,
    padding: 16,
  },
  forgotPasswordContainer: {
    flexDirection: "column",
    alignItems: "flex-end",
    width: "100%",
  },
});

export default ResetPassword;
